import { render, staticRenderFns } from "./driverCarEdit.vue?vue&type=template&id=066af0cb&scoped=true"
import script from "./driverCarEdit.vue?vue&type=script&lang=js"
export * from "./driverCarEdit.vue?vue&type=script&lang=js"
import style0 from "./driverCarEdit.vue?vue&type=style&index=0&id=066af0cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066af0cb",
  null
  
)

export default component.exports